import React from "react";
import CourseTopicMaterials from "../../../../hooks/CourseTopicMaterials";
import { fourthFormCourseTopicMaterials} from "../../../../shared/components/FormCourseMaterials/FormCourseMaterials";
import { fourthFormTextBooks } from "../../../../shared/components/FormCourseMaterials/FormImages";
import TextBookImages from "../../../../shared/components/TextBookImages/TextBookImages";

import pic7 from '../../../../assets/Images/PageDetails/FourthForm/Picture7.webp';
import pic8 from '../../../../assets/Images/PageDetails/FourthForm/Picture8.webp';


const FourthFormContent = () => {
  return (
    <>
      <CourseTopicMaterials items={fourthFormCourseTopicMaterials} leftImage={pic7} rightImage={pic8} />
      <TextBookImages images={fourthFormTextBooks} form='Fourth' />
    </>
  );
}

export default FourthFormContent;